/**
 * Centralized language configuration for PickStar
 * Contains common translations and language metadata
 */

import { SUPPORTED_LANGUAGES } from './detectLanguage';

/**
 * Language metadata for UI display
 */
export const languageMetadata = {
  [SUPPORTED_LANGUAGES.EN]: {
    code: 'en',
    name: 'English',
    nativeName: 'English',
    flag: '🇺🇸',
    direction: 'ltr'
  },
  [SUPPORTED_LANGUAGES.ES]: {
    code: 'es',
    name: 'Spanish',
    nativeName: 'Español',
    flag: '🇪🇸',
    direction: 'ltr'
  },
  [SUPPORTED_LANGUAGES.PT_BR]: {
    code: 'pt-br',
    name: 'Portuguese',
    nativeName: 'Português',
    flag: '🇧🇷',
    direction: 'ltr'
  }
};

/**
 * Common translations used across multiple components
 */
export const commonTranslations = {
  // Actions
  cancel: {
    en: 'Cancel',
    es: 'Cancelar',
    'pt-br': 'Cancelar'
  },
  confirm: {
    en: 'Confirm',
    es: 'Confirmar',
    'pt-br': 'Confirmar'
  },
  close: {
    en: 'Close',
    es: 'Cerrar',
    'pt-br': 'Fechar'
  },
  save: {
    en: 'Save',
    es: 'Guardar',
    'pt-br': 'Salvar'
  },
  edit: {
    en: 'Edit',
    es: 'Editar',
    'pt-br': 'Editar'
  },
  delete: {
    en: 'Delete',
    es: 'Eliminar',
    'pt-br': 'Excluir'
  },

  // Navigation
  home: {
    en: 'Home',
    es: 'Inicio',
    'pt-br': 'Início'
  },
  back: {
    en: 'Back',
    es: 'Atrás',
    'pt-br': 'Voltar'
  },
  next: {
    en: 'Next',
    es: 'Siguiente',
    'pt-br': 'Próximo'
  },

  // Time
  today: {
    en: 'Today',
    es: 'Hoy',
    'pt-br': 'Hoje'
  },
  yesterday: {
    en: 'Yesterday',
    es: 'Ayer',
    'pt-br': 'Ontem'
  },
  tomorrow: {
    en: 'Tomorrow',
    es: 'Mañana',
    'pt-br': 'Amanhã'
  },

  // Status
  loading: {
    en: 'Loading...',
    es: 'Cargando...',
    'pt-br': 'Carregando...'
  },
  error: {
    en: 'Error',
    es: 'Error',
    'pt-br': 'Erro'
  },
  success: {
    en: 'Success',
    es: 'Éxito',
    'pt-br': 'Sucesso'
  },

  // Sports betting specific
  bet: {
    en: 'Bet',
    es: 'Apuesta',
    'pt-br': 'Aposta'
  },
  odds: {
    en: 'Odds',
    es: 'Cuotas',
    'pt-br': 'Odds'
  },
  prediction: {
    en: 'Prediction',
    es: 'Predicción',
    'pt-br': 'Previsão'
  },
  analysis: {
    en: 'Analysis',
    es: 'Análisis',
    'pt-br': 'Análise'
  }
};

/**
 * Get a common translation
 * @param {string} key - Translation key
 * @param {string} lang - Language code
 * @returns {string} Translated text or key if not found
 */
export const getCommonTranslation = (key, lang) => {
  return commonTranslations[key]?.[lang] || key;
};
